<div  style="height: 100%; width:50vw; text-align: center;" #edad3container class="svg-container place-self-center flex justify-center">
  <svg #svgContainer class="svg-content" [id]="id" width="100%" height="100%"></svg>
</div>